<app-modal title="Nouveau client" size="md" closeLabel="Fermer" (closed)="annuler()">
  <form [formGroup]="clientForm" class="formulaire_creation">
    <app-form-field label="Identifiant" [required]="true">
      <app-input formControlName="identifiant" [maxLength]="longueurs.identifiant" />
      @if (identifiantDejaUtilise()) {
        <span appFieldError>Cet identifiant est déjà utilisé par un client existant</span>
      } @else {
        <span appFieldHint>Deviendra aussi le code instit de la fiche annuaire</span>
      }
    </app-form-field>

    <app-form-field label="Label">
      <app-input formControlName="label" [maxLength]="longueurs.label" />
    </app-form-field>

    <p class="titre_section">Base de données</p>
    <app-toggle
      label="Créer une nouvelle base"
      [checked]="creerNouvelleBase()"
      (checkedChange)="creerNouvelleBase.set($event)"
    />

    @if (!creerNouvelleBase()) {
      <!-- `app-select` n'implémente pas ControlValueAccessor : le contrôle est
           piloté explicitement (voir PROVENANCE.md, écarts connus). -->
      <app-form-field label="Base de données" [required]="true">
        <app-select
          label="Sélectionner une base"
          trigger="field"
          [clearable]="true"
          selectionMode="single"
          [fullWidth]="true"
          [options]="optionsBases()"
          [selected]="basesSelectionnees()"
          (selectionChange)="choisirBaseDeDonnees($event)"
        />
        <span appFieldHint>La connexion de cette base alimentera la fiche annuaire</span>
      </app-form-field>
    }
  </form>

  @if (creerNouvelleBase()) {
    <form [formGroup]="nouvelleBaseForm" class="formulaire_creation formulaire_nouvelle_base">
      <p class="hint_info">La base sera déclarée dans le registre avec son secret Key Vault</p>

      <app-form-field label="Nom dans le registre (StoreName)" [required]="true">
        <app-input formControlName="storeName" [maxLength]="longueurs.nomBaseDeDonnees" />
        @if (storeNameDejaUtilise()) {
          <span appFieldError>Ce nom de base existe déjà dans le registre</span>
        }
      </app-form-field>

      <app-form-field label="Serveur" [required]="true">
        <app-input formControlName="serveur" [maxLength]="longueurs.serveur" />
      </app-form-field>

      <app-form-field label="Base de données" [required]="true">
        <app-input formControlName="baseDeDonnees" [maxLength]="longueurs.nomBaseDeDonnees" />
      </app-form-field>

      <app-form-field label="Utilisateur">
        <app-input formControlName="utilisateur" [maxLength]="longueurs.utilisateur" />
      </app-form-field>

      <app-form-field label="Mot de passe">
        <app-input
          type="password"
          revealable
          autocomplete="new-password"
          formControlName="motDePasse"
          [maxLength]="longueurs.secret"
        />
      </app-form-field>
    </form>
  }

  <form [formGroup]="clientForm" class="formulaire_creation">
    <p class="titre_section">Options</p>
    <div class="lignes_toggles">
      <app-toggle
        label="Manager"
        [checked]="!!valeursClient().managerIsEnabled"
        (checkedChange)="clientForm.controls.managerIsEnabled.setValue($event)"
      />
      <app-toggle
        label="Meetch"
        [checked]="!!valeursClient().meetchIsEnabled"
        (checkedChange)="clientForm.controls.meetchIsEnabled.setValue($event)"
      />
    </div>

    @if (valeursClient().meetchIsEnabled) {
      <app-form-field label="Clé API Meetch">
        <app-input formControlName="meetchApiKey" [maxLength]="longueurs.secret" />
      </app-form-field>
    }

    <p class="titre_section">Fils de l'eau</p>
    <div class="lignes_toggles">
      <app-toggle
        label="Orange"
        [checked]="!!valeursClient().isOrange"
        (checkedChange)="clientForm.controls.isOrange.setValue($event)"
      />
      <app-toggle
        label="Skidata"
        [checked]="!!valeursClient().isSkidata"
        (checkedChange)="clientForm.controls.isSkidata.setValue($event)"
      />
      <app-toggle
        label="Eventim"
        [checked]="!!valeursClient().isEventim"
        (checkedChange)="clientForm.controls.isEventim.setValue($event)"
      />
    </div>
  </form>

  <div appModalFooter>
    <button type="button" appButton variant="ghost" (click)="annuler()">Annuler</button>
    <button type="button" appButton variant="primary" [disabled]="!peutValider()" (click)="valider()">Créer</button>
  </div>
</app-modal>
